import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import SearchWordSaveWrap from '../../views/searchWord/save/SearchWordSaveWrap';
import { searchWordActions } from '../../store/modules/searchWord';

class SearchWordSaveContainer extends Component {
  /**
   *  검색 키워드 등록/편집 하기
   */
  onSubmit = (data) => {
    const { form, onSubmit } = this.props;

    form.validateFieldsAndScroll((err) => {
      if (err) return;

      onSubmit(data);
    });
  };

  render() {
    const {
      searchWordSave,
      setData,
      isEdit,
      checkKeyword,
      removeSearchWord,
      searchWordId,
      getRelatedSearchWordList,
      form,
    } = this.props;

    return (
      <SearchWordSaveWrap
        form={form}
        searchWordSave={searchWordSave}
        isEdit={isEdit}
        searchWordId={searchWordId}
        setData={setData}
        onSubmit={this.onSubmit}
        checkKeyword={checkKeyword}
        removeSearchWord={removeSearchWord}
        getRelatedSearchWordList={getRelatedSearchWordList}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    searchWordSave: state.searchWord.searchWordSave,
  };
};

const mapDispatchToProps = {
  setData: searchWordActions.setData,
  checkKeyword: searchWordActions.checkKeyword,
  getRelatedSearchWordList: searchWordActions.getRelatedSearchWordList,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(SearchWordSaveContainer));
